const steps = [
  {
    num: '1',
    icon: 'ri-search-line',
    title: 'Discover Products',
    desc: 'Browse through product categories and add interesting finds to your organized spreadsheet for later comparison and analysis.',
  },
  {
    num: '2',
    icon: 'ri-folder-3-line',
    title: 'Organize Information',
    desc: 'Structure your findings with clear categories, price columns, seller ratings, and personal notes all in one unified document.',
  },
  {
    num: '3',
    icon: 'ri-scales-line',
    title: 'Compare Options',
    desc: 'Use side-by-side comparison views to evaluate products across multiple dimensions and identify the best choices.',
  },
  {
    num: '4',
    icon: 'ri-check-double-line',
    title: 'Make Informed Decisions',
    desc: 'Leverage your organized research data to make confident, data-driven purchasing decisions every time.',
  },
];

export default function HowItWorksSection() {
  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="container-custom">
        <div className="text-center mb-12">
          <span className="inline-block px-3 py-1 rounded-full bg-primary-100 text-primary-800 text-xs font-semibold mb-3 uppercase tracking-wide">
            How It Works
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900 mb-3">
            How Superbuy Spreadsheet Works
          </h2>
          <p className="text-foreground-600 max-w-xl mx-auto text-sm md:text-base">
            Four simple steps to transform your shopping research from chaotic browsing to organized decision-making.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-4 gap-6 relative">
          {steps.map((step, idx) => (
            <div key={step.num} className="relative text-center group">
              <div className="w-16 h-16 mx-auto mb-5 rounded-2xl bg-accent-100 flex items-center justify-center group-hover:bg-accent-200 transition-colors">
                <i className={`${step.icon} text-2xl text-accent-700`}></i>
              </div>
              <span className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/3 w-7 h-7 rounded-full bg-primary-500 text-background-50 flex items-center justify-center font-heading font-bold text-xs">
                {step.num}
              </span>
              <h3 className="font-heading font-semibold text-foreground-900 mb-2 text-sm">{step.title}</h3>
              <p className="text-foreground-600 text-xs leading-relaxed">{step.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}